import { useState, useEffect } from "react";
import { useUser } from "src/shared/context/UserContext";

export const useBusinessType = () => {
  const { user } = useUser();
  const [businessType, setBusinessType] = useState<string>("");

  useEffect(() => {
    const type = user?.businessType || "";
    setBusinessType(type);
  }, [user?.businessType]);

  return businessType;
};